module.exports = __webpack_public_path__ + "img/walker-sitter-1.004b91fb.png";